export default __webpack_public_path__ + "static/media/call-to-action-mob.dc38cd38.png";